import React from "react";
import { useNavigate, useSearchParams } from "react-router";
import { useLogout } from "./hooks/useLogout";
import "./index.css";
import { Dialog } from "./components/Dialog";

export function LogoutDialog() {
  const { logout } = useLogout();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const show = searchParams.has("logout");

  const hideDialog = React.useCallback(() => {
    setSearchParams((curr) => {
      curr.delete("logout");
      return curr;
    });
  }, [setSearchParams]);

  const onConfirm = React.useCallback(() => {
    setSearchParams((curr) => {
      curr.delete("logout");
      return curr;
    });
    logout();

    navigate("/", { replace: true });
  }, [setSearchParams, navigate, logout]);

  return (
    <Dialog
      show={show}
      message={"Are you sure you want to logout?"}
      confirmButton={{ text: "Confirm", onClick: onConfirm }}
      onDismiss={hideDialog}
      messageClassName="py-2.5 px-4"
    />
  );
}
